// t530 · B-2268 · «MI GABINETE HOY» EN EL MENÚ DE USUARIO (components/Layout): en un ordenador, en qué gabinete trabaja hoy
// esa persona y, al pulsarlo, la pregunta otra vez para cambiarlo (la abre components/PuestoGabinete). Sale solo si en este
// ordenador se pregunta (no en el móvil, ni sin gabinetes, ni a quien no puede ver fichas).
// Utils sin imports más que los de utils: las guardias que montan el menú lo cargan de verdad. SIN HOOKS a propósito, como
// utils/MenuDeCuentas: lo que pinta se lee del estado al abrir el menú.
import { t } from './i18n'
import { leerEstadoPuesto, eventoElegirGabinete } from './puestoGabineteEstado'

export function MiGabineteEnMenu({ onAntes }) {
  const st = leerEstadoPuesto()
  if (!st || !st.listo) return null
  const suyo = st.actual && st.actual.gabinete_id != null && st.actual.nombre
    ? st.actual.nombre
    : t('utils.MiGabineteEnMenu.ninguno', 'ninguno')
  // t551 · B-2371 · y los otros en los que también está hoy («Gabinete 1 y Gabinete 2»).
  const otros = st.actual && st.actual.gabinete_id != null && Array.isArray(st.actual.otros) ? st.actual.otros.map((o) => o && o.nombre).filter(Boolean) : []
  const nombre = otros.length ? t('utils.MiGabineteEnMenu.y_otros', '{{suyo}} y {{otros}}', { suyo, otros: otros.join(', ') }) : suyo
  const abrir = () => {
    if (onAntes) onAntes()
    try { window.dispatchEvent(new CustomEvent(eventoElegirGabinete())) } catch (_) { /* sin ventana (pruebas) */ }
  }
  return (
    <button type="button" data-menu-mi-gabinete="" onClick={abrir}
      style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '9px 12px', borderRadius: '8px', fontSize: '13px', color: 'var(--text-primary)', fontWeight: '500', width: '100%', border: 'none', background: 'transparent', cursor: 'pointer', textAlign: 'left' }}
      onMouseEnter={(e) => { e.currentTarget.style.background = 'var(--surface-2)' }} onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent' }}>
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <rect x="2" y="3" width="20" height="14" rx="2" /><line x1="8" y1="21" x2="16" y2="21" /><line x1="12" y1="17" x2="12" y2="21" />
      </svg>
      <span style={{ flex: 1, minWidth: 0 }}>{t('utils.MiGabineteEnMenu.mi_gabinete', 'Mi $t(voc.gabinete) hoy: {{nombre}}', { nombre })}</span>
    </button>
  )
}
